import { Product_API } from "../../api";

export async function getData(manufacturer) {
    return fetch(`${Product_API}?manufacturer=${manufacturer}&_limit=20`)
    .then((res) => res.json())
}

                                                                                                                               
export const handleAdd = (item) => {
    item["quantity"] = item.moq;
    if (localStorage.getItem("cart")){
        const cartData = JSON.parse(localStorage.getItem("cart"));
        const check = cartData.filter(allItem => allItem.id === item.id)
        if (check.length === 0) {
            cartData.push(item);
            localStorage.setItem("cart",JSON.stringify(cartData));
            return 1;
        }
        else {
            console.log('here')
            return 0;
        }
    } else {
        let arr = [ item ];
        localStorage.setItem("cart",JSON.stringify(arr));
        return 1;
    }
}
